export type PointsSign = 'plus' | 'minus' | 'none';

export const formattedPoints = (
  points: number,
  sign: PointsSign = 'none',
  lang: string = 'ru-RU'
) => {
  const formatted = new Intl.NumberFormat(lang, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(Math.abs(points));

  switch (sign) {
    case 'plus':
      return `+${formatted}`;
    case 'minus':
      return `-${formatted}`;
    default:
      return formatted;
  }
};
